import { render, staticRenderFns } from "./UhModal.vue?vue&type=template&id=a787beba&scoped=true"
import script from "./UhModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UhModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UhModal.vue?vue&type=style&index=0&id=a787beba&prod&lang=css"
import style1 from "./UhModal.vue?vue&type=style&index=1&id=a787beba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a787beba",
  null
  
)

export default component.exports